import { millisecondsInHour, millisecondsInMinute } from './timeConsts';

export default function extractTimeFromDate(date: Date) {
  const hours = date.getHours();
  const minutes = date.getMinutes();

  const millisecondsFromHours = hours * millisecondsInHour;
  const millisecondsFromMinutes = minutes * millisecondsInMinute;

  return millisecondsFromHours + millisecondsFromMinutes;
}
